import { styled, css } from '$utils/theme'
import { rem } from 'polished'

interface Props {
  height?: any
  width?: any
  cover?: boolean
  objectPosition?: string
}

export const StyledImage = styled.img<Props>`
  ${p =>
    p.height &&
    css`
      height: ${typeof p.height === 'number' ? rem(p.height) : p.height};
    `};
  ${p =>
    p.width &&
    css`
      width: ${typeof p.width === 'number' ? rem(p.width) : p.width};
    `};
  ${p =>
    p.cover &&
    css`
      object-fit: cover;
    `};
  ${p =>
    p.objectPosition &&
    css`
      object-position: ${p.objectPosition};
    `}
`



// WEBPACK FOOTER //
// ./src/views/components/Image/Image.style.ts